import React, {Component } from 'react';

import '../css/iteamvideo.css';

class IteamVideoPlayerComponent extends Component {

    constructor(props) {
        super(props);

        this.state = { paused: true, 
                        subtitlesVisible: 0 // 0 - subtitles shown at bottom   1 - subtitles shown at top    2 - subtitles hidden
                    };

        this.videoPlayPause = this.videoPlayPause.bind(this);
        this.videoStop = this.videoStop.bind(this);
        this.videoMute = this.videoMute.bind(this);
        this.videoVolume = this.videoVolume.bind(this);
        this.videoSeek = this.videoSeek.bind(this);
        this.videoHide = this.videoHide.bind(this);
        this.videoLoadMetadata = this.videoLoadMetadata.bind(this);
        this.videoOnPauseCallback = this.videoOnPauseCallback.bind(this);
        this.videoOnPlayingCallback = this.videoOnPlayingCallback.bind(this);
        this.toggleSubtitles = this.toggleSubtitles.bind(this);
        
        this.videoPlayWrapper = React.createRef();
        this.video = React.createRef();
        this.videoProgress = React.createRef();
        this.videoProgressBar = React.createRef();
    }
    


    componentDidMount() {
        this.video.current.style.left = `0px`;
        this.video.current.style.top = `0px`;
        this.props.setPagePauseVideoCallback(this.videoStop);
    }

    componentWillUnmount() {
        this.props.setPagePauseVideoCallback(null);
    }

    videoPlayPause() {
        if (this.video.current.paused || this.video.current.ended) {
            this.video.current.play();
            this.videoPlayWrapper.current.style.visibility = 'visible';
            this.setState({paused: false});
        } else {
            this.video.current.pause();
            this.videoPlayWrapper.current.style.visibility = 'visible';
            this.setState({paused: true});
        }
    }

    videoStop() {
        console.log('VIDEO STOP IS CALLED');
        this.video.current.pause();
        this.video.current.currentTime = 0;
        this.videoProgress.current.value = 0;
        this.videoPlayWrapper.current.style.visibility = 'hidden';
        this.setState({paused: true});
    }

    videoHide() {
        this.video.current.pause();
        this.videoPlayWrapper.current.style.visibility = 'hidden';
        this.setState({paused: true});
    }

    videoMute() {
        this.video.current.muted = !this.video.current.muted;
    }

    videoVolume(dir) {
        let currentVolume = Math.floor(this.video.current.volume * 10) / 10;
        if (dir === '+') {
            if (currentVolume < 1) {
                this.video.current.volume += 0.1;
            }
        } else if (dir === '-') {
            if (currentVolume > 0) {
                this.video.current.volume -= 0.1;
            }
        }
    }

    videoOnPauseCallback() {
        this.setState({paused: true});
    }

    videoOnPlayingCallback() {
        this.setState({paused: false});
    }

    videoLoadMetadata() {
        this.videoProgress.current.setAttribute('max', this.video.current.duration);
    }

    videoTimeUpdate() {
        if (!this.videoProgress.current.getAttribute('max')) {
            this.videoProgress.current.setAttribute('max', this.video.current.duration);
        }
        this.videoProgress.current.value = this.video.current.currentTime;
        this.videoProgressBar.current.style.width = Math.floor((this.video.current.currentTime / this.video.current.duration) * 100) + '%';
    }

    videoSeek(e) {
        if (e.type === 'mousemove' && e.buttons !== 1) {
            return;
        }
        var pos = (e.pageX  - (this.videoProgress.current.offsetLeft + this.videoProgress.current.offsetParent.offsetLeft)) / this.videoProgress.current.offsetWidth;
        this.video.current.currentTime = pos * this.video.current.duration;
    }

    toggleSubtitles() {
        this.setState({subtitlesVisible: (this.state.subtitlesVisible + 1) % 3 });
    }

    render() {

        let subtitleurl = this.props.videourl.replace(/\.\w+$/, '_bottom.vtt');
        let subtitlesToggleButton = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M169.6,0H30.4C13.7,0,0,13.7,0,30.4v139.1C0,186.2,13.7,199.9,30.4,199.9h139.1c16.7,0,30.4-13.7,30.4-30.4V30.4c.1-16.7-13.6-30.4-30.3-30.4ZM16.4,118.7c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12,0,0,0-3.6,0-3.6ZM115.2,160.1c0,6.6-5.4,12-12,12H28.4c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h74.7c6.6,0,12,5.4,12,12v3.6h0ZM179.2,160.1c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6ZM179.2,122.3c0,6.6-5.4,12-12,12h-74.7c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h74.7c6.6,0,12,5.4,12,12v3.6Z"/></svg>;

        if (this.state.subtitlesVisible === 0) {
            subtitleurl = this.props.videourl.replace(/\.\w+$/, '_bottom.vtt');
            subtitlesToggleButton = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M169.6,0H30.4C13.7,0,0,13.7,0,30.4v139.1C0,186.2,13.7,199.9,30.4,199.9h139.1c16.7,0,30.4-13.7,30.4-30.4V30.4c.1-16.7-13.6-30.4-30.3-30.4ZM16.4,118.7c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12,0,0,0-3.6,0-3.6ZM115.2,160.1c0,6.6-5.4,12-12,12H28.4c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h74.7c6.6,0,12,5.4,12,12v3.6h0ZM179.2,160.1c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6ZM179.2,122.3c0,6.6-5.4,12-12,12h-74.7c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h74.7c6.6,0,12,5.4,12,12v3.6Z"/></svg>;
        } else if (this.state.subtitlesVisible === 1) {
            subtitleurl = this.props.videourl.replace(/\.\w+$/, '_top.vtt');
            subtitlesToggleButton = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M169.6,0H30.4C13.7,0,0,13.7,0,30.4v139.1c0,16.7,13.7,30.4,30.4,30.4h139.1c16.7,0,30.4-13.7,30.4-30.4V30.4c.1-16.7-13.6-30.4-30.3-30.4ZM16.4,42.9c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12,0,0,0-3.6,0-3.6ZM115.2,84.3c0,6.6-5.4,12-12,12H28.4c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h74.7c6.6,0,12,5.4,12,12v3.6h0ZM179.2,84.3c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6ZM179.2,46.5c0,6.6-5.4,12-12,12h-74.7c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h74.7c6.6,0,12,5.4,12,12v3.6Z"/></svg>;
        } else {
            subtitlesToggleButton = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M169.6,0H30.4C13.7,0,0,13.7,0,30.4v139.1C0,186.2,13.7,199.9,30.4,199.9h139.1c16.7,0,30.4-13.7,30.4-30.4V30.4c.1-16.7-13.6-30.4-30.3-30.4ZM16.4,79.3c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12v-3.6ZM179.2,120.7c0,6.6-5.4,12-12,12h-30.9c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h30.9c6.6,0,12,5.4,12,12v3.6ZM186.4,23.3l-44,44h24.8c6.6,0,12,5.4,12,12v3.6c0,6.6-5.4,12-12,12h-52.4l-10.3,10.3c5.9.7,10.6,5.8,10.6,11.9v3.6h0c0,6.6-5.4,12-12,12h-26.2l-53.7,53.7c-2.7,2.7-7,2.7-9.7,0-2.7-2.7-2.7-7,0-9.7l44-44h-29.2c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h56.8l10.2-10.2h-2.9c-6.6,0-12-5.4-12-12v-3.6c0-6.6,5.4-12,12-12h30.5l53.7-53.7c2.7-2.7,7-2.7,9.7,0,2.7,2.7,2.7,7,0,9.7Z"/></svg>;
        }


        return(<div className='iTeamVideoPlayerContainer'>
            <div className='iTeamVideoPlayerComponentWrapper' ref={this.videoPlayWrapper}>
                <figure className='iTeamVideoPlayerComponent'>
                    <video src={this.props.videourl} ref={this.video}
                        onLoadedMetadata={() => this.videoLoadMetadata()}
                        onTimeUpdate={() => this.videoTimeUpdate()}
                        onPlaying={() => this.videoOnPlayingCallback()}
                        onPause={() => this.videoOnPauseCallback()} >
                        {(this.state.subtitlesVisible !== 2) && <track kind='subtitles' label='English' srcLang='en' src={subtitleurl} default />}
                    </video>
                </figure>
                <div className='iTeamVideoPlayerLeftButtonWrapper'>
                    <button id='closeVideoPanelLeft' type='button' onClick={() => this.videoStop()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle cx="100" cy="100" r="100"/><path d="M125.51,100l34.23-34.23a18,18,0,1,0-25.51-25.51L100,74.49,65.77,40.26A18,18,0,0,0,40.26,65.77L74.49,100,40.26,134.23a18,18,0,1,0,25.51,25.51L100,125.51l34.23,34.23a18,18,0,1,0,25.51-25.51Z"/></svg>
                    </button>
                    <button id='minimizeVideoPanelLeft' type='button' onClick={() => this.videoHide()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle cx="100" cy="100" r="100"/><path d="M166.4,82h-48.4s-36.1,0-36.1,0h0s-48.4,0-48.4,0c-10,0-18,8.1-18,18s8.1,18,18,18h48.4c0,0,36.1,0,36.1,0h0c0,0,48.4,0,48.4,0,10,0,18-8.1,18-18s-8.1-18-18-18Z"/></svg>
                    </button>
                </div>
                <div className='iTeamVideoPlayerRightButtonWrapper'>
                    <button id='minimizeVideoPanelRight' type='button' onClick={() => this.videoHide()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle cx="100" cy="100" r="100"/><path d="M166.4,82h-48.4s-36.1,0-36.1,0h0s-48.4,0-48.4,0c-10,0-18,8.1-18,18s8.1,18,18,18h48.4c0,0,36.1,0,36.1,0h0c0,0,48.4,0,48.4,0,10,0,18-8.1,18-18s-8.1-18-18-18Z"/></svg>
                    </button>
                    <button id='closeVideoPanelRight' type='button' onClick={() => this.videoStop()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle cx="100" cy="100" r="100"/><path d="M125.51,100l34.23-34.23a18,18,0,1,0-25.51-25.51L100,74.49,65.77,40.26A18,18,0,0,0,40.26,65.77L74.49,100,40.26,134.23a18,18,0,1,0,25.51,25.51L100,125.51l34.23,34.23a18,18,0,1,0,25.51-25.51Z"/></svg>
                    </button>
                </div>
            </div>
            <div className='iTeamVideoPlayerControls'>
                <button id='playpause' type='button' onClick={() => this.videoPlayPause()}>
                    {this.state.paused ? 
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M0,180.57V19.43A19.41,19.41,0,0,1,28.14,2.07L189.23,82.64a19.41,19.41,0,0,1,0,34.72L28.14,197.93A19.41,19.41,0,0,1,0,180.57Z"/></svg>
                    :
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><rect x="31.35" width="55.31" height="200" rx="24.27" transform="translate(118 200) rotate(-180)"/><rect x="113.35" width="55.31" height="200" rx="24.27" transform="translate(282 200) rotate(-180)"/></svg>
                    }
                    
                </button>
                <button id='stop' type='button' onClick={() => this.videoStop()}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><rect x="26" y="26" width="148" height="148" transform="translate(200) rotate(90)"/></svg>
                </button>
                <button id='showHideSubtitle' type='button' onClick={() => this.toggleSubtitles()}>
                    {subtitlesToggleButton}
                </button>
                <progress id='progress' value='0' min='0' ref={this.videoProgress} onClick={this.videoSeek} onMouseMove={this.videoSeek}>
                    <span id='progress-bar' ref={this.videoProgressBar}></span>
                </progress>
                <button id='volinc' type='button' onClick={() => this.videoVolume('+')}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M147.93,45.52V12.76a12.73,12.73,0,0,0-20.7-9.93L74,45.61H30a30,30,0,0,0-30,30v48.82a30,30,0,0,0,30,30H74l53.26,42.78a12.73,12.73,0,0,0,20.7-9.93V151.48a53,53,0,0,0,0-106ZM147,141a42.5,42.5,0,1,1,42.5-42.5A42.5,42.5,0,0,1,147,141Z"/><rect x="140.09" y="64" width="13.83" height="69" rx="6.91" transform="translate(245.5 -48.5) rotate(90)"/><rect x="140.09" y="64" width="13.83" height="69" rx="6.91" transform="translate(294 197) rotate(-180)"/></svg>
                </button>
                <button id='voldec' type='button' onClick={() => this.videoVolume('-')}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M147.93,45.52V12.76a12.73,12.73,0,0,0-20.7-9.93L74,45.61H30a30,30,0,0,0-30,30v48.82a30,30,0,0,0,30,30H74l53.26,42.78a12.73,12.73,0,0,0,20.7-9.93V151.48a53,53,0,0,0,0-106ZM147,141a42.5,42.5,0,1,1,42.5-42.5A42.5,42.5,0,0,1,147,141Z"/><rect x="140.09" y="64" width="13.83" height="69" rx="6.91" transform="translate(245.5 -48.5) rotate(90)"/></svg>
                </button>
                <button id='mute' type='button' onClick={() => this.videoMute()}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M147.93,45.52V12.76a12.73,12.73,0,0,0-20.7-9.93L74,45.61H30a30,30,0,0,0-30,30v48.82a30,30,0,0,0,30,30H74l53.26,42.78a12.73,12.73,0,0,0,20.7-9.93V151.48a53,53,0,0,0,0-106ZM147,141a42.5,42.5,0,1,1,42.5-42.5A42.5,42.5,0,0,1,147,141Z"/><rect x="140.09" y="64" width="13.83" height="69" rx="6.91" transform="translate(112.71 -75.09) rotate(45)"/><rect x="140.09" y="64" width="13.83" height="69" rx="6.91" transform="translate(320.59 64.21) rotate(135)"/></svg>
                </button>
            </div>
        </div>);
    }

}

export default IteamVideoPlayerComponent;